import * as React from 'react';

/**
 * Ícone institucional de mapa do site (mapa dobrado).
 *
 * Mesmo recorte de viewBox usado no [ContrastIcon]: o arquivo de origem vem
 * em 40×40 com o desenho ocupando as 20 unidades centrais, então `8 8 24 24`
 * mantém a proporção conteúdo/moldura igual à dos demais ícones da barra.
 */
export const SiteMapIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="8 8 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <path
      d="M29.4613 12.6585C29.3714 12.5885 29.2668 12.5399 29.1554 12.5164C29.0439 12.4928 28.9286 12.4949 28.8181 12.5226L23.0872 13.9551L17.3356 11.0789C17.1754 10.9989 16.9918 10.979 16.8181 11.0226L10.8181 12.5226C10.6559 12.5632 10.5118 12.6568 10.4089 12.7886C10.306 12.9204 10.25 13.0829 10.25 13.2501V26.7501C10.25 26.8641 10.276 26.9765 10.326 27.0789C10.376 27.1814 10.4486 27.271 10.5385 27.3412C10.6283 27.4113 10.7329 27.46 10.8444 27.4837C10.9559 27.5073 11.0713 27.5052 11.1819 27.4776L16.9128 26.0451L22.6644 28.9214C22.7688 28.9728 22.8836 28.9998 23 29.0001C23.0613 29.0001 23.1224 28.9925 23.1819 28.9776L29.1819 27.4776C29.3441 27.437 29.4882 27.3434 29.5911 27.2116C29.694 27.0798 29.75 26.9174 29.75 26.7501V13.2501C29.75 13.136 29.724 13.0235 29.674 12.921C29.624 12.8184 29.5512 12.7287 29.4613 12.6585ZM17.75 12.9632L22.25 15.2132V27.037L17.75 24.787V12.9632ZM11.75 13.836L16.25 12.711V24.6642L11.75 25.7892V13.836ZM28.25 26.1642L23.75 27.2892V15.336L28.25 14.211V26.1642Z"
      fill="currentColor"
    />
  </svg>
);

export default SiteMapIcon;
